import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useAuth } from "@/context/AuthContext";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created");
      navigate("/");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="register-page">
      <p className="label-eyebrow mb-3">Account</p>
      <h1 className="font-serif text-5xl tracking-tighter mb-10">Create account</h1>

      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <div>
          <label className="label-eyebrow block mb-2">Full name</label>
          <input type="text" required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} className="aj-input" data-testid="register-name-input" />
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Email</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="aj-input" data-testid="register-email-input" />
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Phone</label>
          <input type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="aj-input" data-testid="register-phone-input" />
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Password (min 6)</label>
          <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="aj-input" data-testid="register-password-input" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="register-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="register-submit-btn">{loading ? "Creating…" : "Create Account"}</button>
      </form>

      <p className="mt-8 text-sm text-[#6A747D] text-center">
        Already have an account? <Link to="/login" className="underline underline-offset-4 hover:text-[#333E48]">Sign in</Link>
      </p>
    </div>
  );
}
